import React from 'react'
import { Switch, Route } from 'react-router-dom'
// home
import ChatRecentSF from '../pages/superUser/account/ChatRecentSF'
import RiskRegisterSF from '../pages/superUser/account/RiskRegisterSF'
import ChatFollowUpSF from '../pages/superUser/account/ChatFollowUpSF'
import AccountListPageSF from '../pages/superUser/account/AccountListPageSF'
import LeadDashboardPageSF from '../pages/superUser/account/LeadDashboardPageSF'
import LeadListPageSf from '../pages/superUser/account/LeadListPageSF'
import SalesTargetListPageSF from '../pages/superUser/account/SalesTargetListPageSF'
import SalesReportListPageSF from '../pages/superUser/account/SalesReportListPageSF'
import SalesChartPageSF from '../pages/superUser/account/SalesChartPageSF'
import SalesContactPageSF from '../pages/superUser/account/SalesContactPageSF'
import PendingMessageApprovalListPageSF from '../pages/superUser/util/PendingMessageApprovalListPageSF'
import PendingMessageApprovalWhatsAppListPageSF from '../pages/superUser/util/PendingMessageApprovalWhatsAppListPageSF'
import PendingMessageApprovalEmailListPageSF from '../pages/superUser/util/PendingMessageApprovalEmailListPageSF'
import ComplianceTaskListPageSF from '../pages/superUser/util/ComplianceTaskListPageSF'
import NachReportPageSF from '../pages/superUser/loanList/NachReportPageSF'

// nodal transactions
import NodalTxnListPageSF from '../pages/superUser/nodalTxn/NodalTxnListPageSF'
import ReconTxnListPageSF from '../pages/superUser/nodalTxn/ReconTxnListPageSF'
import NodalCashFlowPageSF from '../pages/superUser/nodalTxn/NodalCashFlowPageSF'
import EscrowTxnListPageSF from '../pages/superUser/nodalTxn/EscrowTxnListPageSF'
import PendingTxnListPageSF from '../pages/superUser/nodalTxn/PendingTxnListPageSF'
import CurrentTxnListPageSF from '../pages/superUser/nodalTxn/CurrentTxnListPageSF'
import ReconciliationPageSF from '../pages/superUser/nodalTxn/ReconciliationPageSF'
import ExternalTxnListPageSF from '../pages/superUser/nodalTxn/ExternalTxnListPageSF'
import MutualFundsListPageSF from '../pages/superUser/nodalTxn/MutualFundsListPageSF'
import FixedDepositListPageSF from '../pages/superUser/nodalTxn/FixedDepositListPageSF'
import ClientWiseSummaryPageSF from '../pages/superUser/nodalTxn/ClientWiseSummaryPageSF'
import CurrReconciliationPageSF from '../pages/superUser/nodalTxn/CurrReconciliationPageSF'
import CurrFixedDepositListPageSF from '../pages/superUser/nodalTxn/CurrFixedDepositListPageSF'
// account
import KYCPageSF from '../pages/superUser/account/KYCPageSF'
import ChatPageSF from '../pages/superUser/account/ChatPageSF'
import FileListPageSF from '../pages/superUser/account/FileListPageSF'
import ClimeDocPageSF from '../pages/superUser/account/ClimeDocPageSF'
import VendorsPageSF from '../pages/superUser/account/VendorsPageSF'
import EventListPageSF from '../pages/superUser/account/EventListPageSF'
import EventTrackerPageSF from '../pages/superUser/account/EventTrackerPageSF'
import OnboardingTrackerPageSF from '../pages/superUser/account/OnboardingTrackerPageSF'
import CustomersPageSF from '../pages/superUser/account/CustomersPageSF'
import KYCUserListPageSF from '../pages/superUser/account/KYCUserListPageSF'
import CibilReportPageSF from '../pages/superUser/account/CreditReportPageSF'
import AccountDetailPageSF from '../pages/superUser/account/AccountDetailPageSF'
import TriangulationPageSF from '../pages/superUser/clientTxn/TriangulationPageSF'
import EligibleEnterprise2xSF from '../pages/superUser/account/EligibleEnterprise2xSF'
import ReceivableFinancingPageSF from '../pages/superUser/account/ReceivableFinancingPageSF'
import RfMonthlyLimitPageSF from '../pages/superUser/account/RfMonthlyLimitPageSF'
import CustomerInvoices2PageSF from '../pages/superUser/account/CustomerInvoices2PageSF'
import RfTransactionListPageSF from '../pages/superUser/account/RfTransactionListPageSF'
import TriangulationChartPageSF from '../pages/superUser/clientTxn/TriangulationChartPageSF'
import ClientTxnCatTotalListPageSF from '../pages/superUser/clientTxn/ClientTxnCatTotalListPageSF'
import ClientTransactionListPageSF from '../pages/superUser/clientTxn/ClientTransactionListPageSF'
import ClientTxnCatTransactionListPageSF from '../pages/superUser/clientTxn/ClientTxnCatTransactionListPageSF'
import ClientTxnCashTransactionListPageSF from '../pages/superUser/clientTxn/ClientTxnCashTransactionListPageSF'
import ReceivableFinancing2PageSF from '../pages/superUser/account/ReceivableFinancing2PageSF'
import CustomerInvoiceCollectionPageSF from '../pages/superUser/account/CustomerInvoiceCollectionPageSF'
import RecurringTransferPageSF from '../pages/superUser/account/RecurringTransferPageSF'
import DaysPastDuePageSf from '../pages/superUser/account/DaysPastDuePageSF'
import MessageApprovalListPageSF from '../pages/superUser/util/MessageApprovalListPageSF'
import MessageApprovalWhatsAppListPageSF from '../pages/superUser/util/MessageApprovalWhatsAppListPageSF'
import MessageApprovalEmailListPageSF from '../pages/superUser/util/MessageApprovalEmailListPageSF'
import SOAPageSF from '../pages/superUser/transaction/SOAPageSF'
// client Data
import MCAReportPageSF from '../pages/superUser/clientData/MCAReportPageSF'
import GSTReportPageSF from '../pages/superUser/clientData/GSTReportPageSF'
import ITRReportPageSF from '../pages/superUser/clientData/ITRReportPageSF'
import CalculationsPageSF from '../pages/superUser/clientData/CalculationsPageSF'
import DataCollectionPage2SF from '../pages/superUser/clientData/DataCollectionPage2SF'
// score
import ScoreCardPageSF from '../pages/superUser/score/ScoreCardPageSF'
import ScoreParamsPageSF from '../pages/superUser/score/ScoreParamsPageSF'
// transaction
import CashFlowPageSF from '../pages/superUser/transaction/CashFlowPageSF'
import CashFlow2PageSF from '../pages/superUser/transaction/CashFlow2PageSF'
import BankAccountPageSF from '../pages/superUser/transaction/BankAccountPageSF'
import PayableListPageSF from '../pages/superUser/transaction/PayableListPageSF'
import SuTransactionListPageSF from '../pages/superUser/transaction/SuTransactionListPageSF'
import EMITrackerPageSF from '../pages/superUser/virtualTxn/EMICollectionPageSF'
// developer
import DBConfigPageUI from '../pages/superUser/developer/DBConfigPageUI'
import TestAccountListPageSF from '../pages/superUser/developer/TestAccountListPageSF'
//  settings
// import MasterTemplatePageSF from '../pages/superUser/settings/MasterTemplatePageSF'
import MasterLoanAgrGeneralPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrGeneralPageSF'
import MasterLoanAgrNbfcPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrNbfcPageSF'
import MasterLoanAgrPoPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrPoPageSF'
import MasterLoanAgrPpaPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrPpaPageSF'
import MasterLoanAgrEvPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrEvPageSF'
import MasterLoanAgrPledgePageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrPledgePageSF'
import MasterLoanAgrNduPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrNduPageSF'
import MasterLoanAgrEscrowPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrEscrowPageSF'
import MasterLoanAgrSpPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrSpPageSF'
import MasterLoanAgrEscrowSpPageSF from '../pages/superUser/settings/masterTemplates/loanAgreement/MasterLoanAgrEscrowSpPageSF'
import MasterEscrowAgreementPageSF from '../pages/superUser/settings/masterTemplates/escrowAgreement/MasterEscrowAgreementPageSF'
import MasterPledgeAgreementPageSF from '../pages/superUser/settings/masterTemplates/pledgeAgreement/MasterPledgeAgreementPageSF'
import MasterPledgeCumGuaranteePageSF from '../pages/superUser/settings/masterTemplates/pledgeCumGuarantee/MasterPledgeCumGuaranteePageSF'
import MasterNDUPageSF from '../pages/superUser/settings/masterTemplates/ndu/MasterNDUPageSF'
import MasterPersonalGuaranteePageSF from '../pages/superUser/settings/masterTemplates/personalGuarantee/MasterPersonalGuaranteePageSF'
import MasterTermSheetGeneralPageSF from '../pages/superUser/settings/masterTemplates/termSheet/MasterTermSheetGeneralPageSF'
import SupportTemplatePageSF from '../pages/superUser/settings/SupportTemplatePageSF'
import UserListPageSF from '../pages/superUser/settings/UserListPageSF'
import SuSettingsPageSF from '../pages/superUser/settings/SuSettingsPageSF'
import ComplianceListingPageSF from '../pages/superUser/settings/ComplianceListingPageSF'
import MappingListPageSF from '../pages/superUser/settings/MappingListPageSF'
import LoanTypeListPageSF from '../pages/superUser/settings/LoanTypeListPageSF'
import PropertyListPageSF from '../pages/superUser/settings/PropertyListPageSF'
import VendorCOAListPageSF from '../pages/superUser/settings/VendorCOAListPageSF'
import PasswordChangePageSF from '../pages/superUser/settings/PasswordChangePageSF'
import OnboardingEventConfigPageSF from '../pages/superUser/settings/OnboardingEventConfigPageSF'
import OnboardingEventConfigDetailPageSF from '../pages/superUser/settings/OnboardingEventConfigDetailPageSF'
import OnboardingEventConfigEditPageSF from '../pages/superUser/settings/OnboardingEventConfigEditPageSF'
import OnboardingEventConfigAddPageSF from '../pages/superUser/settings/OnboardingEventConfigAddPageSF'
// loan list
import ProcFeePageSF from '../pages/superUser/loanList/ProcFeePageSF'
import FeesTrackerPageSF from '../pages/superUser/loanList/FeesTrackerPageSF'
import StandingInstructionReportPageSF from '../pages/superUser/loanList/StandingInstructionReportPageSF'
import LoanListPageSF from '../pages/superUser/loanList/LoanListPageSF'
import LoanTransactionListPageSF from '../pages/superUser/loan/LoanTransactionListPageSF'
import LoanCashFlowListPageSF from '../pages/superUser/loan/LoanCashFlowListPageSF'
import DistributionPageSF from '../pages/superUser/loanList/DistributionPageSF'
import PenaltyReportPageSF from '../pages/superUser/loanList/PenaltyReportPageSF'
import ClosedLoanListPageSF from '../pages/superUser/loanList/ClosedLoanListPageSF'
import RepaidLoanListPageSF from '../pages/superUser/loanList/RepaidLoanListPageSF'
import AccountLoanListPageSF from '../pages/superUser/loanList/AccountLoanListPageSF'
import DocumentRepositoryAccountListPageSF from '../pages/superUser/account/DocumentRepositoryAccountListPageSF'
import DocumentRepositoryLoanListPageSF from '../pages/superUser/loanList/DocumentRepositoryLoanListPageSF'
import DocumentRepositoryPageSF from '../pages/superUser/loan/DocumentRepositoryPageSF'
import ExpiredLoanListPageSF from '../pages/superUser/loanList/ExpiredLoanListPageSF'
import DisbursedLoanListPageSF from '../pages/superUser/loanList/DisbursedLoanListPageSF'
import AllRepaymentListPageSF from '../pages/superUser/loanList/AllRepaymentListPageSF'
import AllRepaymentListPage2SF from '../pages/superUser/loanList/AllRepaymentListPage2SF'
import RepaymentListOldPageSF from '../pages/superUser/loanList/RepaymentListOldPageSF'
import TotalDisbursementPageSF from '../pages/superUser/loanList/TotalDisbursementPageSF'
import EsccValidationPageSF from '../pages/superUser/loanList/EsccValidationPageSF'
import MonthlyDisbursementPageSF from '../pages/superUser/loanList/MonthlyDisbursementPageSF'
import ReceivableFinancingPage2SF from '../pages/superUser/loanList/ReceivableFinancingPage2SF'
import RepaymentInitiatedListPageSF from '../pages/superUser/loanList/RepaymentInitiatedListPageSF'
import ConditionSubsequentStatusPageSF from '../pages/superUser/loanList/ConditionSubsequentStatusPageSF'
import ConditionSubsequentRemarksPageSF from '../pages/superUser/loanList/ConditionSubsequentRemarksPageSF'
import EscrowAccountBalancePageSF from '../pages/superUser/loanList/EscrowAccountBalancePageSF'
// loan details
import DsraPageSF from '../pages/superUser/loan/DsraPageSF'
import SecurityReportPageSF from '../pages/superUser/loan/SecurityReportPageSF'
import TotalIncomePageSF from '../pages/superUser/loanList/TotalIncomePageSF'
import TotalIncomeMonthlyPageSF from '../pages/superUser/loanList/TotalIncomeMonthlyPageSF'
import LoanFeePageSF from '../pages/superUser/loan/LoanFeePageSF'
import AddendumPageSF from '../pages/superUser/loan/AddendumPageSF'
// import TemplatePageSF from '../pages/superUser/loan/TemplatePageSF'
import TermSheetDocumentSchedulesPageSF from '../pages/superUser/loan/TermSheetDocumentSchedulesPageSF'
import TermSheetDocumentGeneralTermsPageSF from '../pages/superUser/loan/TermSheetDocumentGeneralTermsPageSF'
import LoanAgreementGeneralTermsPageSF from '../pages/superUser/loan/LoanAgreementGeneralTermsPageSF'
import LoanAgreementLoanSpecificTermsPageSF from '../pages/superUser/loan/LoanAgreementLoanSpecificTermsPageSF'
import LoanAgreementPledgeNduTermsPageSF from '../pages/superUser/loan/LoanAgreementPledgeNduTermsPageSF'
import LoanAgreementEscrowTermsPageSF from '../pages/superUser/loan/LoanAgreementEscrowTermsPageSF'
import LoanAgreementSchedulesPageSF from '../pages/superUser/loan/LoanAgreementSchedulesPageSF'
import LoanAgreementAnnexuresPageSF from '../pages/superUser/loan/LoanAgreementAnnexuresPageSF'
import ResolutionsPageSF from '../pages/superUser/loan/ResolutionsPageSF'
import EscrowAgreementGeneralTermsPageSF from '../pages/superUser/loan/EscrowAgreementGeneralTermsPageSF'
import EscrowAgreementSchedulesPageSF from '../pages/superUser/loan/EscrowAgreementSchedulesPageSF'
import PledgeAgreementGeneralTermsPageSF from '../pages/superUser/loan/PledgeAgreementGeneralTermsPageSF'
import PledgeAgreementSchedulesPageSF from '../pages/superUser/loan/PledgeAgreementSchedulesPageSF'
import PledgeCumGuaranteeGeneralTermsPageSF from '../pages/superUser/loan/PledgeCumGuaranteeGeneralTermsPageSF'
import PledgeCumGuaranteeSchedulesPageSF from '../pages/superUser/loan/PledgeCumGuaranteeSchedulesPageSF'
import NDUGeneralTermsPageSF from '../pages/superUser/loan/NDUGeneralTermsPageSF'
import NDUSchedulesPageSF from '../pages/superUser/loan/NDUSchedulesPageSF'
import CoBorrowerNDUGeneralTermsPageSF from '../pages/superUser/loan/CoBorrowerNDUGeneralTermsPageSF'
import CoBorrowerNDUSchedulesPageSF from '../pages/superUser/loan/CoBorrowerNDUSchedulesPageSF'
import PersonalGuaranteeGeneralTermsPageSF from '../pages/superUser/loan/PersonalGuaranteeGeneralTermsPageSF'
import PersonalGuaranteeSchedulesPageSF from '../pages/superUser/loan/PersonalGuaranteeSchedulesPageSF'
import TermSheetPageSF from '../pages/superUser/loan/TermSheetPageSF'
import TermSheetApprovalPageSF from '../pages/superUser/loan/TermSheetApprovalPageSF'
import TokenSListPageSF from '../pages/superUser/loan/TokenSListPageSF'
import GeneralTokenListPageSF from '../pages/superUser/loan/GeneralTokenListPageSF'
import TransactionTokenListPageSF from '../pages/superUser/loan/TransactionTokenListPageSF'
import RepaymentPageSF from '../pages/superUser/loan/RepaymentPageSF'
import CompliancePageSF from '../pages/superUser/loan/CompliancePageSF'
import RepaymentPage2SF from '../pages/superUser/loan/RepaymentPage2SF'
import LoanSizingPageSF from '../pages/superUser/loan/LoanSizingPageSF'
import PrepaymentPageSF from '../pages/superUser/loan/PrepaymentPageSF'
import LoanDetailPageSF from '../pages/superUser/loan/LoanDetailPageSF'
import VehicleTypeListPageSF from '../pages/superUser/loan/VehicleTypeListPageSF'
import ProjectDetailPageSF from '../pages/superUser/loan/ProjectDetailPageSF'
import ProjectPageSF from '../pages/superUser/loan/ProjectPageSF'
import ReportCardPageSF from '../pages/superUser/loan/ReportCardPageSF'
import BroadTermsPageSF from '../pages/superUser/loan/BroadTermsPageSF'
import InterestRatePageSF from '../pages/superUser/loan/InterestRatePageSF'
import SecurityCoverPageSF from '../pages/superUser/loan/SecurityCoverPageSF'
import SuBankAccountPageSF from '../pages/superUser/loan/SuBankAccountPageSF'
import LoanSanctionPageSF from '../pages/superUser/loan/LoanSanctionPageSF'
import UseOfProceedsPageSF from '../pages/superUser/loan/UseOfProceedsPageSF'
import DocumentSignPageSF from '../pages/superUser/loan/DocumentSignPageSF'
import AmortizationPageSF from '../pages/superUser/loan/AmortizationPageSF'
import LegalRemarksPageSF from '../pages/superUser/loan/LegalRemarksPageSF'
import LoanMonitoringPageSF from '../pages/superUser/loan/LoanMonitoringPageSF'
import DataCollectionPageSF from '../pages/superUser/loan/DataCollectionPageSF'
import RecommendationPageSF from '../pages/superUser/loan/RecommendationPageSF'
import LoanFeasibilityPageSF from '../pages/superUser/loan/LoanFeasibilityPageSF'
import LoanDisbursementPageSF from '../pages/superUser/loan/LoanDisbursementPageSF'
import ComplianceStatusPageSF from '../pages/superUser/loan/ComplianceStatusPageSF'
import SecurityRemarksPageSF from '../pages/superUser/loan/SecurityRemarksPageSF'
import MonitoringRemarksPageSF from '../pages/superUser/loan/MonitoringRemarksPageSF'
import PenalInterestRemarksPageSF from '../pages/superUser/loan/PenalInterestRemarksPageSF'
import UseOfProceedsDraftPageSF from '../pages/superUser/loan/UseOfProceedsDraftPageSF'
import DocumentListPageSF from '../pages/superUser/account/DocumentListPageSF'
import AllRepaymentSummaryPageSF from '../pages/superUser/loanList/AllRepaymentSummaryPageSF'
import DocTemplatePageSF from '../pages/superUser/settings/DocTemplatePageSF'
// Vehicle
import VehicleTypeCountPageSF from '../components/superUser/reports/VehicleTypeCountPageSF'
//product Item
import ProductItemListPageSF from '../pages/superUser/account/ProductItemListPageSF'
//compliances
import Compliance2PageSF from '../pages/superUser/account/Compliance2PageSF'
import ComplianceReportPageSF from '../pages/superUser/account/ComplianceReportPageSF'
import ComplianceRetailReportPageSF from '../pages/superUser/account/ComplianceRetailReportPageSF'
import AccountConfigNotificationPageSF from '../pages/superUser/account/AccountConfigNotificationPageSF'

// other
import LeegalityAccountMappingListPageSF from '../pages/superUser/LeegalityAccountMappingListPageSF'
import LoanStatementPageSF from '../pages/superUser/loan/LoanStatementPageSF'
import DailyTransactionListPageSF from '../pages/superUser/transaction/DailyTransactionListPageSF'
import JournalEntriesListPageSF from '../pages/superUser/util/JournalEntriesListPageSF'
import LendersReportPageSF from '../pages/superUser/loan/LendersReportPageSF'
import ALMReportPageSF from '../pages/superUser/loan/ALMReportPageSF.js'
import EMITracker2PageSF from '../pages/superUser/loanList/EMITracker2PageSF'
import AllChatPageSF from '../pages/superUser/account/AllChatPageSF'
import AccountChatPageSF from '../pages/superUser/account/AccountChatPageSF'
import ChatFilesPageSF from '../pages/superUser/clientData/ChatFilesPageSF'
import VendorDiligencePageSF from '../pages/superUser/account/VendorDiligencePageSF'
import LoanChequePageSF from '../pages/superUser/loan/LoanChequePageSF'
import ChatMessageList2SF from '../components/superUser/account/ChatMessageList2SF'
import MonitoringIntelligenceSF from '../pages/superUser/account/MonitoringIntelligenceSF'
import NachFailureRecordsPageSF from '../components/superUser/loan/NachFailureRecordsPageSF'
import NACHDetailsPageSF from '../pages/superUser/account/NACHDetailsPageSF'
import MonitoringIntelligenceRetailSF from '../pages/superUser/account/MonitoringIntelligenceRetailSF'
import LoanDisbursementChecklistPageSF from '../pages/superUser/loan/LoanDisbursementChecklistPageSF'
import MISummarySF from '../pages/superUser/account/MISummarySF'
// events
import EventsListPageSF from '../pages/superUser/events/EventsListPageSF'
// loan type and event mapping
import WhatsAppChatPageSF from '../pages/superUser/account/WhatsAppChatPageSF'
import WhatsAppTemplatePageSF from '../pages/superUser/settings/WhatsAppTemplatePageSF'
import LoanTypeAndEventMappingPageSF from '../pages/superUser/settings/LoanTypeAndEventMappingPageSF'
import PriorDaysConfigPageSF from '../pages/superUser/settings/PriorDaysConfigPageSF'
import FailedExternalPageSF from '../pages/superUser/util/FailedExternalPageSF'
import ExternalDataCachePageSF from '../pages/superUser/util/ExternalDataCachePageSF'
import OnBoardingDocsPageSF from '../pages/superUser/account/OnBoardingDocsPageSF'
import OnBoardingDataPageSF from '../pages/superUser/loan/OnBoardingDataPageSF.js'
import OfftakerCounterpartyPanDetailsPageSF from '../pages/superUser/loan/OfftakerCounterpartyPanDetailsPageSF'
import RepeatTransactionPageSF from '../pages/superUser/loanList/RepeatTransactionPageSF'
import ScheduleVIISummaryPageSF from '../pages/superUser/account/ScheduleVIISummaryPageSF.js'

const SuperUserRouteUI = ({ context }) =>
  <Switch>

    <Route exact path='/su/repeatTransactions'
      render={() =>
        <RepeatTransactionPageSF context={context} />
      }
    />
    <Route exact path='/su/preApprovedLoans'
      render={() =>
        <RepeatTransactionPageSF context={context} />
      }
    />
    <Route exact path='/su'
      render={() =>
        <AccountListPageSF context={context} />
      }
    />
    <Route exact path='/su/chats/recent'
      render={() =>
        <ChatRecentSF context={context} />
      }
    />
    <Route exact path='/su/allchats'
      render={() =>
        <AllChatPageSF context={context} />
      }
    />
    <Route exact path='/su/riskRegister'
      render={() =>
        <RiskRegisterSF context={context} />
      }
    />
    <Route exact path='/su/chats/followUp'
      render={() =>
        <ChatFollowUpSF context={context} />
      }
    />
    <Route exact path='/su/docs'
      render={() =>
        <ClimeDocPageSF context={context} />
      }
    />
    <Route exact path='/su/dpd'
      render={() =>
        <DaysPastDuePageSf context={context} />
      }
    />

    <Route exact path='/su/dpd/:year/:month'
      render={() =>
        <DaysPastDuePageSf context={context} />
      }
    />

    <Route exact path='/su/leads'
      render={() =>
        <LeadListPageSf context={context} />
      }
    />

    <Route exact path='/su/salesTargets/report'
      render={() =>
        <SalesTargetListPageSF context={context} />
      }
    />

    <Route exact path='/su/salesTargets/chart'
      render={() =>
        <SalesChartPageSF context={context} />
      }
    />

    <Route exact path='/su/salesTargets/contacts'
      render={() =>
        <SalesContactPageSF context={context} />
      }
    />

    <Route exact path='/su/salesReport'
      render={() =>
        <SalesReportListPageSF context={context} />
      }
    />

    <Route exact path='/su/messageApprovals'
      render={() =>
        <PendingMessageApprovalListPageSF context={context} />
      }
    />

    <Route exact path='/su/messageApprovals/whatsapp'
      render={() =>
        <PendingMessageApprovalWhatsAppListPageSF context={context} />
      }
    />

    <Route exact path='/su/messageApprovals/email'
      render={() =>
        <PendingMessageApprovalEmailListPageSF context={context} />
      }
    />

    <Route exact path='/su/compliances'
      render={() =>
        <Compliance2PageSF context={context} />
      }
    />

    <Route exact path='/su/compliance'
      render={() =>
        <ComplianceReportPageSF context={context} />
      }
    />

    <Route exact path='/su/compliance/retail'
      render={() =>
        <ComplianceRetailReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/nachFailure'
      render={() =>
        <NachFailureRecordsPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/nach'
      render={() =>
        <NACHDetailsPageSF context={context} />
      }
    />

    <Route exact path='/su/monitoringIntelligence'
      render={() =>
        <MonitoringIntelligenceSF context={context} />
      }
    />

    <Route exact path='/su/monitoringIntelligence/retail'
      render={() =>
        <MonitoringIntelligenceRetailSF context={context} />
      }
    />
    <Route exact path='/su/monitoringIntelligence/summary'
      render={() =>
        <MISummarySF context={context} />
      }
    />

    <Route exact path='/su/calendar'
      render={() =>
        <ComplianceTaskListPageSF context={context} />
      }
    />

    {/* Transactions */}
    <Route exact path='/su/txns/pending'
      render={() =>
        <PendingTxnListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber'
      render={() =>
        <NodalTxnListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/reconciliation'
      render={() =>
        <ReconTxnListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/unreconciled'
      render={() =>
        <ReconciliationPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/external'
      render={() =>
        <ExternalTxnListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/fd'
      render={() =>
        <FixedDepositListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/mutualFunds'
      render={() =>
        <MutualFundsListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/nodal/:accountNumber/cashFlow'
      render={() =>
        <NodalCashFlowPageSF context={context} />
      }
    /><Route exact path='/su/txns/nodal/:accountNumber/summary'
      render={() =>
        <ClientWiseSummaryPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/clime/:accountNumber'
      render={() =>
        <CurrentTxnListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/clime/:accountNumber/unreconciled'
      render={() =>
        <CurrReconciliationPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/clime/:accountNumber/fd'
      render={() =>
        <CurrFixedDepositListPageSF context={context} />
      }
    />
    <Route exact path='/su/txns/clime/:accountNumber/mutualFunds'
      render={() =>
        <MutualFundsListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/schedukeVIISummary'
      render={() =>
        <ScheduleVIISummaryPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/txns/escrow/:accountNumber'
      render={() =>
        <EscrowTxnListPageSF context={context} />
      }
    />
    {/* Vehicle */}
    <Route exact path='/su/vehicles'
      render={() =>
        <VehicleTypeCountPageSF context={context} />
      }
    />
    {/* Product Item */}
    <Route exact path='/su/accounts/:accountId/productItems'
      render={() =>
        <ProductItemListPageSF context={context} />
      }
    />

       {/* Lead Dashboard */}
    <Route exact path='/su/leadDashboard'
      render={() =>
        <LeadDashboardPageSF context={context} />
      }
    />

    {/* Account */}
    <Route exact path='/su/accounts'
      render={() =>
        <AccountListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/360'
      render={() =>
        <AccountDetailPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/documents'
      render={() =>
        <DocumentListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId'
      render={() =>
        <KYCPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/kyc'
      render={() =>
        <KYCPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/directors'
      render={() =>
        <KYCUserListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/chat'
      render={() =>
        <ChatPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/chats'
      render={() =>
        <AccountChatPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/users/:userId/chats'
      render={() =>
        <ChatMessageList2SF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/whatsappChat'
      render={() =>
        <WhatsAppChatPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/dataCollection'
      render={() =>
        <DataCollectionPage2SF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/mca'
      render={() =>
        <MCAReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/gst'
      render={() =>
        <GSTReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/chatFiles'
      render={() =>
        <ChatFilesPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/itr'
      render={() =>
        <ITRReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/calculations'
      render={() =>
        <CalculationsPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/customers'
      render={() =>
        <CustomersPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/invoices'
      render={() =>
        <CustomerInvoices2PageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/rf'
      render={() =>
        <ReceivableFinancingPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/collections'
      render={() =>
        <CustomerInvoiceCollectionPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/rfTxns'
      render={() =>
        <RfTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/limit'
      render={() =>
        <RfMonthlyLimitPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/vendors'
      render={() =>
        <VendorsPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/recurringTransfers'
      render={() =>
        <RecurringTransferPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/scoreParams'
      render={() =>
        <ScoreParamsPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/scoreCard'
      render={() =>
        <ScoreCardPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/files'
      render={() =>
        <FileListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/cashFlow'
      render={() =>
        <CashFlowPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/cashFlow2'
      render={() =>
        <CashFlow2PageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/bankAccounts'
      render={() =>
        <BankAccountPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/payables'
      render={() =>
        <PayableListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/messageApprovals'
      render={() =>
        <MessageApprovalListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/bankAccounts/:bankAccountId'
      render={() =>
        <BankAccountPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/txns3/'
      render={() =>
        <SuTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/txns3/:bankAccountId'
      render={() =>
        <SuTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/emis/'
      render={() =>
        <EMITrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/emis/:year/:month'
      render={() =>
        <EMITrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/clienTxns/'
      render={() =>
        <ClientTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/clienTxns/:bankAccountId'
      render={() =>
        <ClientTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/clientTxnCats'
      render={() =>
        <ClientTxnCatTotalListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/clientTxnCatTransactions/:category/:financialYear'
      render={() =>
        <ClientTxnCatTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/clientTxnCashTransactions/:category/:year/:month'
      render={() =>
        <ClientTxnCashTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/triangulations'
      render={() =>
        <TriangulationPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/triangulations/charts'
      render={() =>
        <TriangulationChartPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/events'
      render={() =>
        <EventListPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/eventTracker'
      render={() =>
        <EventTrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/onboardingTracker'
      render={() =>
        <OnboardingTrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/eligible2x'
      render={() =>
        <EligibleEnterprise2xSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/loans'
      render={() =>
        <AccountLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/documentRepository'
      render={() =>
        <DocumentRepositoryAccountListPageSF context={context} />
      }
    />
    <Route exact path='/su/documentRepository/accounts/:accountId/loans'
      render={() =>
        <DocumentRepositoryLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/documentRepository/loans/:loanId'
      render={() =>
        <DocumentRepositoryPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/receivableFinancing'
      render={() =>
        <ReceivableFinancing2PageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/creditReport'
      render={() =>
        <CibilReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/configNotification'
      render={() =>
        <AccountConfigNotificationPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/onBoardingDocs'
      render={() =>
        <OnBoardingDocsPageSF context={context} />
      }
    />

    <Route exact path='/su/accounts/:accountId/messageApprovals/whatsapp'
      render={() =>
        <MessageApprovalWhatsAppListPageSF context={context} />
      }
    />

    <Route exact path='/su/accounts/:accountId/messageApprovals/email'
      render={() =>
        <MessageApprovalEmailListPageSF context={context} />
      }
    />

    <Route exact path='/su/onboarding-events'
      render={() =>
        <OnboardingEventConfigPageSF context={context} />
      }
    />

    <Route exact path='/su/onboarding-events/new'
      render={() =>
        <OnboardingEventConfigAddPageSF context={context} />
      }
    />

    <Route exact path='/su/onboarding-events/:eventCode'
      render={() =>
        <OnboardingEventConfigDetailPageSF context={context} />
      }
    />

    <Route exact path='/su/onboarding-events/:eventCode/edit'
      render={() =>
        <OnboardingEventConfigEditPageSF context={context} />
      }
    />

    {/*Loans*/}
    <Route exact path='/su/loans'
      render={() =>
        <LoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/docTemplates'
      render={() =>
        <DocTemplatePageSF context={context} />
      }
    />

    <Route exact path='/su/loans/:loanId/transactions'
      render={() =>
        <LoanTransactionListPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/pan/:pan'
      render={() =>
        <OfftakerCounterpartyPanDetailsPageSF context={context} />
      }
    />

    <Route exact path='/su/loans/:loanId/cashFlow'
      render={() =>
        <LoanCashFlowListPageSF context={context} />
      }
    />

    <Route exact path='/su/accounts/:accountId/statements'
      render={() =>
        <LoanStatementPageSF context={context} />
      }
    />

    <Route exact path='/su/loansDisbursed/nonRetail'
      render={() =>
        <DisbursedLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/loansDisbursed/retail'
      render={() =>
        <DisbursedLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/loansRepaid'
      render={() =>
        <RepaidLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/loansExpired'
      render={() =>
        <ExpiredLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/loansClosed'
      render={() =>
        <ClosedLoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/receivableFinancing'
      render={() =>
        <ReceivableFinancingPage2SF context={context} />
      }
    />
    <Route exact path='/su/loans/stp'
      render={() =>
        <LoanListPageSF context={context} />
      }
    />
    <Route exact path='/su/remarks'
      render={() =>
        <ConditionSubsequentRemarksPageSF context={context} />
      }
    />
    <Route exact path='/su/virtualAccountBalances'
      render={() =>
        <EscrowAccountBalancePageSF context={context} />
      }
    />
    <Route exact path='/su/csStatus'
      render={() =>
        <ConditionSubsequentStatusPageSF context={context} />
      }
    />
    <Route exact path='/su/disbursements'
      render={() =>
        <TotalDisbursementPageSF context={context} />
      }
    />
    <Route exact path='/su/escc-validation'
      render={() =>
        <EsccValidationPageSF context={context} />
      }
    />
    <Route exact path='/su/disbursements/monthly'
      render={() =>
        <MonthlyDisbursementPageSF context={context} />
      }
    />
    <Route exact path='/su/distribution'
      render={() =>
        <DistributionPageSF context={context} />
      }
    />
    <Route exact path='/su/security'
      render={() =>
        <SecurityReportPageSF context={context} />
      }
    />

    <Route exact path='/su/security/:year/:month'
      render={() =>
        <SecurityReportPageSF context={context} />
      }
    />

    <Route exact path='/su/lenders'
      render={() =>
        <LendersReportPageSF context={context} />
      }
    />

    <Route exact path='/su/lenders/:year/:month'
      render={() =>
        <LendersReportPageSF context={context} />
      }
    />

    <Route exact path='/su/almReport'
      render={() =>
        <ALMReportPageSF context={context} />
      }
    />

    <Route exact path='/su/txns/daily'
      render={() =>
        <DailyTransactionListPageSF context={context} />
      }
    />

    <Route exact path='/su/penalty'
      render={() =>
        <PenaltyReportPageSF context={context} />
      }
    />
    <Route exact path='/su/penalty/:year/:month'
      render={() =>
        <PenaltyReportPageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/v1'
      render={() =>
        <AllRepaymentListPageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/v1/:year/:month'
      render={() =>
        <AllRepaymentListPageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/v1/:type'
      render={() =>
        <AllRepaymentListPageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/v1/:type/:year/:month'
      render={() =>
        <AllRepaymentListPageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/v2'
      render={() =>
        <AllRepaymentListPage2SF context={context} />
      }
    />
    <Route exact path='/su/repayments/v2/:year/:month'
      render={() =>
        <AllRepaymentListPage2SF context={context} />
      }
    />
    <Route exact path='/su/repayments/v2/:type'
      render={() =>
        <AllRepaymentListPage2SF context={context} />
      }
    />
    <Route exact path='/su/repayments/v2/:type/:year/:month'
      render={() =>
        <AllRepaymentListPage2SF context={context} />
      }
    />
    <Route exact path='/su/repayments/2.0'
      render={() =>
        <EMITracker2PageSF
          context={context}
          onlyType='business'
        />
      }
    />
    <Route exact path='/su/repayments/2.0/:year/:month'
      render={() =>
        <EMITracker2PageSF context={context} />
      }
    />
    <Route exact path='/su/repayments/2.0/:year/:month/retail'
      render={() =>
        <EMITracker2PageSF
          context={context}
          onlyType='individual'
        />
      }
    />
    <Route exact path='/su/overdues'
      render={() =>
        <AllRepaymentSummaryPageSF context={context} />
      }
    />
    <Route exact path='/su/overdues/:year/:month'
      render={() =>
        <AllRepaymentSummaryPageSF context={context} />
      }
    />
    <Route exact path='/su/fees'
      render={() =>
        <ProcFeePageSF context={context} />
      }
    />
    <Route exact path='/su/fees/feeTracker2'
      render={() =>
        <FeesTrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/standingInstructionReport'
      render={() =>
        <StandingInstructionReportPageSF context={context} />
      }
    />
    <Route exact path='/su/nachReport'
      render={() =>
        <NachReportPageSF context={context} />
      }
    />
    <Route exact path='/su/nachReport/:year/:month'
      render={() =>
        <NachReportPageSF context={context} />
      }
    />
    <Route exact path='/su/accounts/:accountId/journalEntries'
      render={() =>
        <JournalEntriesListPageSF context={context} />
      }
    />

    <Route exact path='/su/accounts/:accountId/soa'
      render={() =>
        <SOAPageSF context={context} />
      }
    />

    <Route exact path='/su/repayments/initiated'
      render={() =>
        <RepaymentInitiatedListPageSF context={context} />
      }
    />
    <Route exact path='/su/repaymentsOld'
      render={() =>
        <RepaymentListOldPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId'
      render={() =>
        <LoanDetailPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/disbursement'
      render={() =>
        <LoanDisbursementPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/disbursementChecklist'
      render={() =>
        <LoanDisbursementChecklistPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/dataCollection'
      render={() =>
        <DataCollectionPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/projects'
      render={() =>
        <ProjectDetailPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/termSheet'
      render={() =>
        <TermSheetPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/termSheet/approval'
      render={() =>
        <TermSheetApprovalPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/termSheet/schedules'
      render={() =>
        <TermSheetDocumentSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/termSheet/general'
      render={() =>
        <TermSheetDocumentGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/broadTerms'
      render={() =>
        <BroadTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/onboardingData'
      render={() =>
        <OnBoardingDataPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/broadTerms/preview'
      render={() =>
        <BroadTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/tokenS'
      render={() =>
        <TokenSListPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/tokenUW'
      render={() =>
        <GeneralTokenListPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/tokenL'
      render={() =>
        <TransactionTokenListPageSF context={context} />
      }
    />
    {/* <Route exact path='/su/loans/:loanId/ftlTemplate'
      render={() =>
        <TemplatePageSF context={context} />
      }
    /> */}
    {/* Loan Document Routes */}
    <Route exact path='/su/loans/:loanId/resolutions'
      render={() =>
        <ResolutionsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/general'
      render={() =>
        <LoanAgreementGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/loanSpecific'
      render={() =>
        <LoanAgreementLoanSpecificTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/escrowSp'
      render={() =>
        <LoanAgreementEscrowTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/pledgeNdu'
      render={() =>
        <LoanAgreementPledgeNduTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/schedules'
      render={() =>
        <LoanAgreementSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanAgreement/annexures'
      render={() =>
        <LoanAgreementAnnexuresPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/escrowAgreement/general'
      render={() =>
        <EscrowAgreementGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/escrowAgreement/schedules'
      render={() =>
        <EscrowAgreementSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/pledgeAgreement/general'
      render={() =>
        <PledgeAgreementGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/pledgeAgreement/schedules'
      render={() =>
        <PledgeAgreementSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/pledgeCumGuarantee/general'
      render={() =>
        <PledgeCumGuaranteeGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/pledgeCumGuarantee/schedules'
      render={() =>
        <PledgeCumGuaranteeSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/ndu/general'
      render={() =>
        <NDUGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/ndu/schedules'
      render={() =>
        <NDUSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/coBorrowerNdu/general'
      render={() =>
        <CoBorrowerNDUGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/coBorrowerNdu/schedules'
      render={() =>
        <CoBorrowerNDUSchedulesPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/personalGuarantee/general'
      render={() =>
        <PersonalGuaranteeGeneralTermsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/personalGuarantee/schedules'
      render={() =>
        <PersonalGuaranteeSchedulesPageSF context={context} />
      }
    />
    {/* Loan Agreement Routes */}
    <Route exact path='/su/master/loanAgreement/general'
      render={() =>
        <MasterLoanAgrGeneralPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/nbfc'
      render={() =>
        <MasterLoanAgrNbfcPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/po'
      render={() =>
        <MasterLoanAgrPoPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/ppa'
      render={() =>
        <MasterLoanAgrPpaPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/ev'
      render={() =>
        <MasterLoanAgrEvPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/pledge'
      render={() =>
        <MasterLoanAgrPledgePageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/ndu'
      render={() =>
        <MasterLoanAgrNduPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/escrow'
      render={() =>
        <MasterLoanAgrEscrowPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/sp'
      render={() =>
        <MasterLoanAgrSpPageSF context={context} />
      }
    />
    <Route exact path='/su/master/loanAgreement/escrow_sp'
      render={() =>
        <MasterLoanAgrEscrowSpPageSF context={context} />
      }
    />
    {/* New Agreement Type Routes */}
    <Route exact path='/su/master/escrowAgreement'
      render={() =>
        <MasterEscrowAgreementPageSF context={context} />
      }
    />
    <Route exact path='/su/master/pledgeAgreement'
      render={() =>
        <MasterPledgeAgreementPageSF context={context} />
      }
    />
    <Route exact path='/su/master/pledgeCumGuarantee'
      render={() =>
        <MasterPledgeCumGuaranteePageSF context={context} />
      }
    />
    <Route exact path='/su/master/ndu'
      render={() =>
        <MasterNDUPageSF context={context} />
      }
    />
    <Route exact path='/su/master/personalGuarantee'
      render={() =>
        <MasterPersonalGuaranteePageSF context={context} />
      }
    />
    <Route exact path='/su/master/termSheet/general'
      render={() =>
        <MasterTermSheetGeneralPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/vehicleTypes'
      render={() =>
        <VehicleTypeListPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/fees'
      render={() =>
        <LoanFeePageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/esigning'
      render={() =>
        <DocumentSignPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/project'
      render={() =>
        <ProjectPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/addendum'
      render={() =>
        <AddendumPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/compliance/:compliance'
      render={() =>
        <ComplianceStatusPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/monitoring'
      render={() =>
        <MonitoringRemarksPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/legalRemarks'
      render={() =>
        <LegalRemarksPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/loanCheque'
      render={() =>
        <LoanChequePageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/compliance'
      render={() =>
        <CompliancePageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/penalInterest'
      render={() =>
        <PenalInterestRemarksPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/security'
      render={() =>
        <SecurityRemarksPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/proceeds'
      render={() =>
        <UseOfProceedsPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/proceeds/draft'
      render={() =>
        <UseOfProceedsDraftPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/repayments/v1'
      render={() =>
        <RepaymentPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/repayments/v2'
      render={() =>
        <RepaymentPage2SF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/prepayment'
      render={() =>
        <PrepaymentPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/monitoring'
      render={() =>
        <LoanMonitoringPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/bankAccounts'
      render={() =>
        <SuBankAccountPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/dsra'
      render={() =>
        <DsraPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/amortization'
      render={() =>
        <AmortizationPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/sizing'
      render={() =>
        <LoanSizingPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/recommendation'
      render={() =>
        <RecommendationPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/feasibility'
      render={() =>
        <LoanFeasibilityPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/interestRate'
      render={() =>
        <InterestRatePageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/securityCover'
      render={() =>
        <SecurityCoverPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/reportCard'
      render={() =>
        <ReportCardPageSF context={context} />
      }
    />
    <Route exact path='/su/loans/:loanId/sanction'
      render={() =>
        <LoanSanctionPageSF context={context} />
      }
    />

    <Route exact path='/su/income'
      render={() =>
        <TotalIncomePageSF context={context} />
      }
    />

    <Route exact path='/su/income/monthly'
      render={() =>
        <TotalIncomeMonthlyPageSF context={context} />
      }
    />
    <Route exact path='/su/income/monthly/:year/:month'
      render={() =>
        <TotalIncomeMonthlyPageSF context={context} />}
    />
    <Route exact path='/su/emis/'
      render={() =>
        <EMITrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/emis/:year/:month'
      render={() =>
        <EMITrackerPageSF context={context} />
      }
    />
    <Route exact path='/su/leegality/mappings'
      render={() =>
        <LeegalityAccountMappingListPageSF context={context} />
      }
    />

    {/*Developer*/}
    <Route exact path='/su/testdata'
      render={() =>
        <TestAccountListPageSF context={context} />
      }
    />
    <Route exact path='/su/config'
      render={() =>
        <DBConfigPageUI context={context} />
      }
    />

    {/*Settings*/}
    <Route exact path='/su/settings'
      render={() =>
        <SuSettingsPageSF context={context} />
      }
    />
    <Route exact path='/su/loanTypes'
      render={() =>
        <LoanTypeListPageSF context={context} />
      }
    />
    <Route exact path='/su/properties'
      render={() =>
        <PropertyListPageSF context={context} />
      }
    />
    <Route exact path='/su/complianceListing'
      render={() =>
        <ComplianceListingPageSF context={context} />
      }
    />
    <Route exact path='/su/mappings/:mappingGroup'
      render={() =>
        <MappingListPageSF context={context} />
      }
    />
    <Route exact path='/su/vendorPaymentCOAs'
      render={() =>
        <VendorCOAListPageSF context={context} />
      }
    />
    <Route exact path='/su/password'
      render={() =>
        <PasswordChangePageSF context={context} />
      }
    />
    <Route exact path='/su/users'
      render={() =>
        <UserListPageSF context={context} />
      }
    />
    <Route exact path='/su/supportTemplates'
      render={() =>
        <SupportTemplatePageSF context={context} />
      }
    />
    <Route exact path='/su/vendorDiligence'
      render={() =>
        <VendorDiligencePageSF context={context} />
      }
    />

    <Route exact path='/su/failedExternal'
      render={() =>
        <FailedExternalPageSF context={context} />
      }
    />
    <Route exact path='/su/externalDataCache'
      render={() =>
        <ExternalDataCachePageSF context={context} />
      }
    />
    {/* Events */}
    <Route exact path='/su/events'
      render={() =>
        <EventsListPageSF context={context} />
      }
    />
    {/* Loan Type and Event Mapping */}
    <Route exact path='/su/loanTypeAndEventMapping'
      render={() =>
        <LoanTypeAndEventMappingPageSF context={context} />
      }
    />
    {/* WhatsApp Template */}
    <Route exact path='/su/whatsappTemplate'
      render={() =>
        <WhatsAppTemplatePageSF context={context} />
      }
    />
    {/* Prior Days Config */}
    <Route exact path='/su/priorDaysConfig'
      render={() =>
        <PriorDaysConfigPageSF context={context} />
      }
    />
  </Switch>

export default SuperUserRouteUI
